// Components
import { BasicDropdownListOption } from '../components/BasicDropdownListOption';
import { PrefixedDropdownListOption } from '../components/PrefixedDropdownListOption';
export var DropdownListOptions = {
    basic: BasicDropdownListOption,
    withPrefix: PrefixedDropdownListOption,
};
//# sourceMappingURL=DropdownListOptions.js.map